// src/utils/logger.js
const isDev = process.env.NODE_ENV === 'development';
const timestamp = () => new Date().toISOString();

const logger = {
  log:  (...args) => { if (isDev) console.log(`[LOG  ${timestamp()}]`,  ...args); },
  info: (...args) => { if (isDev) console.info(`[INFO ${timestamp()}]`, ...args); },
  warn: (...args) => { if (isDev) console.warn(`[WARN ${timestamp()}]`, ...args); },
  error: (...args) => {           console.error(`[ERROR ${timestamp()}]`, ...args); },
};

Object.freeze(logger);
export default logger;
